import { render } from "./AdminProfile.vue?vue&type=template&id=25e3dfa0&scoped=true"
import script from "./AdminProfile.vue?vue&type=script&lang=js"
export * from "./AdminProfile.vue?vue&type=script&lang=js"

import "./AdminProfile.vue?vue&type=style&index=0&id=25e3dfa0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e3dfa0"]])

export default __exports__